export default {
    form: (state) => state.form,
    copyData: (state) => state.copyData,
    dynamicInputValuesModified: (state) => state.dynamicInputValuesModified,
    getField: (state) => {
        return (key) => {
            return _.get(state.form, key)
        }
    },
    ocrStatusFront:(state)=> state.ocrStatusFront,
    cardTypeOverride:(state)=> state.cardTypeOverride,
    ocrStatusBack:(state)=> state.ocrStatusBack,
    getRegState: (state) => {
        return (key) => {
            return _.get(state, key)
        }},
    journeyInitialized: (state) => state.journeyInitialized,
    pepCondition: (state) => state.pepCondition,
}
